import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CalendarAppModule } from '@modules/calendar-app/calendar-app.module';
import { CalendarAppContextDirective } from '@modules/calendar-app/directives/app-calendar-app-context.directive';
import { ContactsModule } from '@modules/contacts/contacts.module';
import { ContactsAppContextDirective } from '@modules/contacts/directives/app-contacts-app-context.directive';
import { FilesAppContextDirective } from '@modules/files/directives/app-files-app-context.directive';
import { FilesModule } from '@modules/files/files.module';
import { MailAppContextDirective } from '@modules/messages/directives/app-mail-app-context.directive';
import { MessagesModule } from '@modules/messages/messages.module';
import { ModalModule } from '@modules/modal/modal.module';
import { NotesAppContextDirective } from '@modules/notes/directives/app-notes-app-context.directive';
import { SheetsAppContextDirective } from '@modules/sheets/directives/app-sheets-app-context.directive';
import { NotesModule } from '@modules/notes/notes.module';
import { SheetsModule } from '@modules/sheets/sheets.module';
import { TaskingAppContextDirective } from '@modules/tasks/directives/app-tasking-app-context.directive';
import { TasksModule } from '@modules/tasks/tasks.module';
import { FullFormPopupComponent } from './components/full-form-popup/full-form-popup.component';
import { MailEditorPopupComponent } from './components/mail-editor-popup/mail-editor-popup.component';
import { PopupWrapperComponent } from './components/popup-wrapper/popup-wrapper.component';
import { PopupRoutingModule } from './popup-routing.module';
import { PopupGuardService } from './services/popup-guard.service';
import { PopupService } from './services/popup.service';

@NgModule({
  imports: [
    CalendarAppModule,
    CommonModule,
    ContactsModule,
    FilesModule,
    MessagesModule,
    ModalModule,
    NotesModule,
    SheetsModule,
    PopupRoutingModule,
    TasksModule,
    MailAppContextDirective,
    CalendarAppContextDirective,
    TaskingAppContextDirective,
    NotesAppContextDirective,
    SheetsAppContextDirective,
    ContactsAppContextDirective,
    FilesAppContextDirective,
  ],
  declarations: [FullFormPopupComponent, MailEditorPopupComponent, PopupWrapperComponent],
  providers: [PopupService, PopupGuardService],
})
export class PopupModule {}
